import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogCancelButton,
  DialogDestructiveActionButton,
} from "../../../components";

function RecipientListStepResetDialog({
  onReset,
  onClose,
  title,
  text,
  resetText,
  ...rest
}) {
  const { t } = useTranslation();

  return (
    <Dialog {...rest} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{text}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <DialogCancelButton
          data-test-id="reset-dialog-button-cancel"
          onClick={onClose}
        >
          {t("Cancel")}
        </DialogCancelButton>
        <DialogDestructiveActionButton
          data-test-id="reset-dialog-button-reset"
          onClick={onReset}
        >
          {resetText}
        </DialogDestructiveActionButton>
      </DialogActions>
    </Dialog>
  );
}

export default memo(RecipientListStepResetDialog);
